/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Dev_Backend_Prod_SocialInputs */

const en_mobile_dev_backend_prod_social = /** @type {(inputs: Mobile_Dev_Backend_Prod_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⚠️ Google and Apple sign-in are unavailable on production from a dev build. Use email and password.`)
};

const es_mobile_dev_backend_prod_social = /** @type {(inputs: Mobile_Dev_Backend_Prod_SocialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⚠️ El inicio de sesión con Google y Apple no está disponible en producción desde una compilación de desarrollo. Usa correo y contraseña.`)
};

/**
* | output |
* | --- |
* | "⚠️ Google and Apple sign-in are unavailable on production from a dev build. Use email and password." |
*
* @param {Mobile_Dev_Backend_Prod_SocialInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_dev_backend_prod_social = /** @type {((inputs?: Mobile_Dev_Backend_Prod_SocialInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Dev_Backend_Prod_SocialInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_dev_backend_prod_social(inputs)
	return en_mobile_dev_backend_prod_social(inputs)
});